// FLAGS: none
// Assessed, and clean on purpose: invited/opened/registered totals only. Same rule as
// AttendanceSummary — no roster row reaches this file.
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@openup/shared/primitives/ui/card";
import { SessionAttendance } from "@src/models/spaces";

interface AttendanceFunnelProps {
  funnel: SessionAttendance["funnel"];
}

/** Email-invite funnel: Invited -> Opened -> Registered, bars relative to Invited. */
const AttendanceFunnel = ({ funnel }: AttendanceFunnelProps) => {
  const steps = [
    { label: "Invited", value: funnel.invited },
    { label: "Opened", value: funnel.opened },
    { label: "Registered", value: funnel.registered },
  ];
  // Bars are relative to the top of the funnel; guard divide-by-zero.
  const max = funnel.invited || 1;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Invite funnel</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        {steps.map((step) => (
          <div key={step.label}>
            <div className="mb-1 flex items-center justify-between text-sm">
              <span className="text-gray-700">{step.label}</span>
              <span className="font-medium text-indigo-800">{step.value}</span>
            </div>
            <div className="h-2 w-full overflow-hidden rounded-full bg-gray-100">
              <div
                className="h-full rounded-full bg-green-600"
                style={{ width: `${Math.round((step.value / max) * 100)}%` }}
              />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default AttendanceFunnel;
